import { createIcon } from './createIcon';

/**
 * A terminal window with a prompt. The package's own mark for "an agent
 * session lives here" — inline rather than imported from a host's asset
 * bundle, so the component tree has no `#/assets/*` dependency.
 */
export const TerminalIcon = createIcon({
  name: 'TerminalIcon',
  viewBox: '0 0 24 24',
  size: 24,
  svgProps: { xmlns: 'http://www.w3.org/2000/svg' },
  children: (
    <>
      <rect
        x="2.5"
        y="4.5"
        width="19"
        height="15"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6 9l3 3-3 3M11 15h6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export default TerminalIcon;
